

<div class="container" *ngIf="routes$ | async as loc">
  <ul class="breadcrumb">
    <li *ngFor="let item of loc; let i = index" [class.active]="i===loc.length-1">
      <a *ngIf="i<loc.length-1" [routerLink]="item.tracker">{{ item.label }}</a>
      <span *ngIf="i===loc.length-1">{{ item.label }}</span>
    </li>
  </ul>
</div>
